<template>
    <div>
        <b-row>
            <b-col cols="12" class="order-xl-1 filter-form company-setting">
                <b-card class="p-3" header-class="p-3" :title="$translate('company_settings')" shadow type="secondary">
                    <b-card-body class="mt-3">
                        <b-overlay :show="submitting" rounded="sm">
                            <form @submit.prevent class="form-sample">
                                <h2 class="text-muted">
                                    {{ $translate('business_information') }}
                                </h2>
                                <div class="pl-lg-4">
                                    <b-row>
                                        <b-col cols="12" lg="4" class="mt-3">
                                            <link-modal v-model="model.logo" @upload-btn-clicked="uploadClicked"></link-modal>
                                        </b-col>
                                        <b-col cols="12" lg="4" class="mt-3">
                                            <h6 class="text-muted">{{ model.name }}</h6>
                                            <h6 class="text-muted">{{ model.tagline }}</h6>
                                        </b-col>
                                    </b-row>
                                    <b-row class="my-4">
                                        <b-col cols="12">
                                            <h6 class="heading-small">{{ $translate('company_settings_note') }}</h6>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" lg="4" class="mt-3">
                                            <label for="name" class="mb-3"><strong>{{ $translate('name') }}</strong></label>
                                            <b-form-input :placeholder="$translate('name')" id="input-name" v-model="model.name"
                                                type="text"></b-form-input>
                                        </b-col>
                                        <b-col cols="12" lg="4" class="mt-3">
                                            <label for="City" class="mb-3"><strong>{{ $translate('business_tagline')
                                            }}</strong></label>
                                            <b-form-input id="input-business-tagline" :placeholder="$translate('business_tagline')" v-model="model.tagline"
                                                type="text"></b-form-input>

                                        </b-col>
                                        <b-col cols="12" lg="4" class="my-3">
                                            <label for="name" class="mb-3"><strong>{{ $translate('email') }}</strong></label>
                                            <b-form-input id="input-email" :placeholder="'example@oms.com'" v-model="model.email"
                                                type="email"></b-form-input>
                                        </b-col>
                                        <b-col cols="12" lg="4" class="mt-3 ">
                                            <label for="name" class="mb-3"><strong>{{ $translate('telephone')
                                            }}</strong></label>
                                            <b-form-input id="input-mobile" placeholder="+(876)111-1111" v-model="model.phone"
                                                type="text"></b-form-input>
                                        </b-col>
                                        
                                        <b-col cols="12" md="4" class="my-3">
                                            <label for="customer_id" class="mb-3"><strong>{{ $translate('customer')
                                            }}</strong></label>
                                            <customer-type-ahead
                                                v-model="model.customer_id"
                                                required
                                            ></customer-type-ahead>
                                        </b-col>
                                        <b-col cols="12" md="4" class="my-3">
                                            <label for="input-time_zone" class="mb-3"><strong>{{ $translate('time_zone') }}</strong>&nbsp;<small>{{ $translate('time_zone_note') }}</small></label>
                                            <b-form-input id="input-time_zone" :step="30" placeholder="-300" v-model="model.time_zone" :min="-720" :max="720"
                                                type="number"></b-form-input>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" class="mt-3">
                                            <label class="mb-3 mt-3"><strong>{{ $translate('slider_images_new') }}</strong> </label>
                                            <div key="attachment">
                                                <b-modal v-model="isVisible" hide-footer class="pt-8" header-class="p-0"
                                                    content-class="custom-model-wrap">
                                                    <template #modal-title="{ cancel }">
                                                        <div class="title-block text-center p-2">{{ $translate('uploaded_file') }}
                                                        </div>
                                                        <div class="close-btn" @click="cancel()">×</div>
                                                    </template>
                                                    <a v-if="['docx', 'doc', 'xls', 'xlsx'].includes(
                                                        imageModel && imageModel.file_extension
                                                    )
                                                        " :href="imageModel && imageModel.url">
                                                        <div class="btn btn-success btn-sm">
                                                            <i class="fa fa-file fa-2x"></i>
                                                        </div>
                                                    </a>
                                                    <a v-else-if="imageModel && imageModel.file_extension == 'pdf'"
                                                        :href="imageModel && imageModel.url">
                                                        <div class="btn delete-button btn-sm">
                                                            <i class="fa fa-file-pdf fa-2x"></i>
                                                        </div>
                                                    </a>
                                                    <b-img v-else :src="imageModel && imageModel.url" fluid
                                                        alt="Responsive image"></b-img>
                                                    <br />
                                                    <div class="text-center">
                                                        <b-button id="delete-attachment-btn" variant="info" class="mt-2 mt-2 btn-fw" v-if="hasPermissionDelete"
                                                            @click="deleteAttachment(imageModel.hash)">{{ $deleteLabel()
                                                            }}</b-button>
                                                    </div>
                                                </b-modal>
                                                <b-modal v-model="showModal" id="add-attachments-modal" centered header-class="p-0"
                                                    footer-class="d-flex justify-content-center border-0"
                                                    content-class="custom-model-wrap" hide-footer>
                                                    <template #modal-title="{ cancel }">
                                                        <div class="text-center">
                                                            <div class="title-block text-center p-2">{{ $translate('files_upload')
                                                            }}
                                                            </div>
                                                            <div class="close-btn" @click="cancel()">×</div>
                                                        </div>
                                                    </template>
                                                    <b-overlay :show="uploading" rounded="sm">
                                                        <b-row>
                                                            <b-col sm="12" xl="8" v-if="this.filelist.length" v-cloak>
                                                                <!--show a list of the selected files, with an input to (optionally) rename the file before upload-->
                                                                <b-list-group>
                                                                    <b-list-group-item class="d-inline-flex p-2"
                                                                        v-for="(file, i) in filelist" :key="i">
                                                                        <!--file name input to rename the file before upload-->
                                                                        <b-form-input id="add-file-name" placeholder="File name..."
                                                                            v-model="filelist[i].fileName" required
                                                                            @change="renameFile(i, filelist[i].fileName)"  ref="inputField"  @click="selectText(i)" />

                                                                        <!--file extension-->
                                                                        <span
                                                                            class="d-inline-flex align-items-center text-muted ml-1 mr-3">.{{
                                                                                filelist[i].extension }}</span>

                                                                        <!--remove file from list (and from upload)-->
                                                                        <b-button id="delete-file-btn" variant="outline-danger" size="sm"
                                                                            @click="remove(filelist.indexOf(file))">
                                                                            <b-icon-trash></b-icon-trash>
                                                                        </b-button>
                                                                    </b-list-group-item>
                                                                </b-list-group>
                                                            </b-col>

                                                            <!--this column contains the file drop area-->
                                                            <!--its width is automatically set based on existance of the file list column and breakpoint-->
                                                            <b-col class="file-drop-column my-4 my-xl-0 p-0">
                                                                <div class="file-drop-area bg-light" @dragover="dragover" @drop="drop">
                                                                    <!--we need an actual file input in order to have the drag&drop functionality-->
                                                                    <!--and the File object(s) containing the files dropped-->
                                                                    <!--We keep it invisible because we want to display something different than a file input-->
                                                                    <input type="file" name="file-input" id="file-input"
                                                                        class="file-input invisible"  @change="onChange" />

                                                                    <!--clicking on this label will trigger the clicked event on the file input-->
                                                                    <!--this will cause the 'choose file' system dialog-->
                                                                    <label for="file-input"
                                                                        class="w-100 text-center cursor-pointer text-muted m-0 px-3 py-5">
                                                                        <p>
                                                                            <b-icon-cloud-upload-fill
                                                                                font-scale="3"></b-icon-cloud-upload-fill>
                                                                        </p>
                                                                        <div>
                                                                            <p class="mb-0">{{ $translate('upload_file_note') }}</p>
                                                                            <p class="mb-0">
                                                                                <span class="text-info">{{
                                                                                    $translate('select_from_computer') }}</span>
                                                                            </p>
                                                                        </div>
                                                                    </label>
                                                                </div>
                                                            </b-col>
                                                        </b-row>
                                                        <div class="text-center mt-4">
                                                            <b-button id="cancel-file-label" variant="info" @click="$bvModal.hide('add-attachments-modal')"
                                                                class="me-3 btn-fw">
                                                                {{ $cancelLabel() }}
                                                            </b-button>
                                                            <b-button id="submit-file-btn" type="submit" :disabled="!filelist.length || uploading"
                                                                variant="info" class="btn-fw" @click="onSubmit()">
                                                                Upload file(s)
                                                            </b-button>
                                                        </div>
                                                    </b-overlay>
                                                </b-modal>
                                                <b-row class="align-items-center">
                                                    <b-col cols="9" md="11">
                                                        <b-container fluid class="form-control ">
                                                            <b-row class="attachment">
                                                                <b-col v-for="(item, index) in attachments" :key="index" md="1"
                                                                    class="mt-2 mt-md-0">

                                                                    <button :id="'doc-file-btn'+index" class="test-doc-file-btn" v-if="['docx', 'doc', 'xls', 'xlsx'].includes(
                                                                        item.file_extension
                                                                    )
                                                                        " @click="setModel(item)">
                                                                        <div class="btn btn-success btn-sm">
                                                                            <i class="fa fa-file fa-2x"></i>
                                                                        </div>
                                                                    </button>
                                                                    <button :id="'pdf-file-btn'+index" class="test-pdf-file-btn" v-else-if="item.file_extension == 'pdf'"
                                                                        @click="setModel(item)">
                                                                        <div class="btn delete-button btn-sm">
                                                                            <i class="fa-solid fa-file-pdf fa-2x"></i>
                                                                        </div>
                                                                    </button>
                                                                    <button :id="'image-file-btn'+index" class="test-image-file-btn" v-else @click="setModel(item)">
                                                                        <b-img :height="imageHeight" :width="imageWidth"
                                                                            :src="item.url" alt="Image 1"></b-img>
                                                                    </button>
                                                                </b-col>
                                                                <b-col v-if="!attachments.length">
                                                                    <h6 class="text-black">{{ $translate('upload_images') }}</h6>
                                                                </b-col>
                                                            </b-row>
                                                        </b-container>
                                                    </b-col>
                                                    <b-col cols="3" md="1">
                                                        <b-button id="upload-cloud-btn" variant="info" @click="showModal = !showModal">
                                                            <b-icon icon="cloud-upload"></b-icon>
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                        </b-col>
                                        <p class="muted-text">{{ $translate('image_size_alert') }} <strong>600x350</strong></p>
                                    </b-row>

                                </div>
                                <h2 class="text-muted my-3">
                                    {{ $translate('business_location') }}
                                </h2>

                                <location-section ref="locationSectionRef" :show="!loaded"
                                    :sectionOnly="false" v-model="model.location_section_id
                                    " :hide-controls="true" @searchMode="evt => (isSearchMode = evt)
                                    " :customer_id="parseInt(model.customer_id, 10) ?? -1
                                    " @set-location-section="(evt) => { setLocationData(evt, 'model') }">
                                </location-section>
                                
                                <!-- <b-tabs align="center" card class="p-0" content-class="tabs" v-model="tabIdx">
                                <b-tab :title="$translate('address')" :title-link-class="'fw-bold'" active>
                                <div class="pl-lg-4">
                                    <b-row>
                                        <b-col cols="12" md="6" class="mt-3">


                                            <label for="address1" class="mb-3"><strong>{{
                                                $translate('address') }}</strong></label>
                                            <b-form-input id="address1" :placeholder="$translate('address')" v-model="model.address1"
                                                type="text"></b-form-input>
                                        </b-col>
                                        <b-col cols="12" md="6" class="mt-3">
                                            <label for="address1" class="mb-3"><strong>{{
                                                $translate('address2') }}</strong></label>
                                            <b-form-input :placeholder="$translate('address2')" v-model="model.address2"
                                                type="text"></b-form-input>

                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" md="6" class="mt-2 pt-2 dd">
                                            <label for="country" class="mb-3"><strong>{{ $translate('country')
                                            }}</strong></label>
                                            <b-form-select class="form-control" id="input-country" @change="fetchState($event)"
                                                v-model="model.country_code" :options="countries">
                                                <template #first>
                                                    <b-form-select-option :value="null">{{ $translate('select_country')
                                                    }}</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                        <b-col cols="12" md="6" class="mt-2 pt-2 dd">
                                            <label for="input-state" class="mb-3"><strong>{{ $translate('state')
                                            }}</strong></label>
                                            <b-form-select class="form-control" id="input-state" value-field="text"
                                                v-model="model.state" :options="states">
                                                <template #first>
                                                    <b-form-select-option :value="null">{{ $translate('select_state')
                                                    }}</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" md="6" class="mt-3">
                                            <label for="County" class="mb-3"><strong>{{ $translate('county') }}</strong></label>
                                            
                                            <b-form-input id="County" label="County" :placeholder="$translate('county')"
                                                v-model="model.county" trim></b-form-input>
                                            
                                        </b-col>
                                        <b-col cols="12" md="6" class="mt-3">
                                            
                                            <label for="City" class="mb-3"><strong>{{ $translate('city') }}</strong></label>
                                            <b-form-input id="City" :placeholder="$translate('city')" v-model="model.city"
                                                trim></b-form-input>
                                            
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" md="6" class="mt-3">
                                            <label for="City" class="mb-3"><strong>{{ $translate('postal_code')
                                            }}</strong></label>
                                            <b-form-input id="Postal" :placeholder="$translate('postal_code')"
                                                v-model="model.postal" trim></b-form-input>
                                        </b-col>
                                        <b-col cols="12" md="6" class="mt-3">
                                            <label for="City" class="mb-3"><strong>{{ $translate('zip_code') }}</strong></label>
                                            <b-form-input id="Zip" :placeholder="$translate('zip_code')"
                                                v-model="model.zip_code" trim></b-form-input>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" md="6" class="mt-3">
                                            <label for="City" class="mb-3"><strong>{{ $translate('latitude') }}</strong></label>
                                            <b-form-input id="Latitude" :placeholder="$translate('latitude')" readonly
                                                v-model="model.latitude" trim></b-form-input>
                                        </b-col>
                                        <b-col cols="12" md="6" class="mt-3">
                                            <label for="City" class="mb-3"><strong>{{ $translate('longitude')
                                            }}</strong></label>
                                            <b-form-input id="Longitude" readonly :placeholder="$translate('longitude')"
                                                v-model="model.longitude" trim></b-form-input>
                                        </b-col>
                                    </b-row>

                                </div>
                                </b-tab>
                                <b-tab :title="$translate('map')" :title-link-class="'fw-bold'">
                                    <b-card-body class="my-4 p-0">
                                        <location-picker v-if="tabIdx == 1" :title="$translate('map_location')" :location="mapLocation"
                                    @set-location="coords => setCoordinates(coords)" @get-location="locationdata => getLocation(locationdata)
                                        " />
                                
                                    </b-card-body>
                                </b-tab>
                                </b-tabs> -->
                                <hr />
                                <h2 class="text-muted mt-4 mb-3">
                                    {{ $translate('color_selection') }}
                                </h2>
                                <b-row class="my-4">
                                    <b-col cols="12">
                                        <h6 class="heading-small">{{ $translate('color_selection_note') }}</h6>
                                    </b-col>
                                </b-row>
                                <!--color selection-->
                                <div class="pl-lg-4">
                                    
                                    <b-row>
                                        <b-col cols="12" md="6">
                                            <label class="mb-3 mt-3"><strong>{{ $translate('background_color_new') }}</strong>
                                            </label>
                                            <b-form-input type="color" id="input-background_color_new"
                                                v-model="model.background_color"></b-form-input>
                                        </b-col>
                                        <b-col cols="12" md="6">
                                            <label class="mb-3 mt-3"><strong>{{ $translate('secondary_background_color') }}</strong> </label>
                                            <b-form-input type="color" id="input-secondary_background_color"
                                                v-model="model.secondary_background_color"></b-form-input>
                                        </b-col>
                                        <b-col cols="12" md="6">
                                            <label class="mb-3 mt-3"><strong>{{ $translate('text_color_new') }}</strong> </label>
                                            <b-form-input type="color" id="input-text_color_new"
                                                v-model="model.text_color"></b-form-input>
                                        </b-col>
                                    </b-row>
                                    
                                </div>
                                <b-col cols="12" class="mt-3">
                                    <label class="mb-3"><strong>{{$translate('crm_setting_attachment')  }} </strong></label>
                                  <view-attachments v-model="model.crm_file"  @upload-btn-clicked="uploadClicked" />
                                </b-col>
                                <hr>
                                <Holiday/>
                                <div class="pl-lg-4 my-4">
                                    <div class="d-flex gap-2 mb-3 mt-3 justify-content-center">
                                        <b-button id="locations-btn" @click="setLocationListMode" variant="info"
                                                :disabled="submitting" v-if="hasPermissionUpdate &&
                                        !isSearchMode
                                        ">{{
                                        $translate('locations')
                                    }}</b-button>
                                        <button id="save-changes-btn" class="btn btn btn-info btn-fw me-2 btn-primary test-save-changes-btn" v-if="hasPermissionUpdate"
                                            variant="primary" @click="updateCompany()" >Save Changes</button>
                                    </div>
                                </div>
                            </form>
                        </b-overlay>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
// import CountryList from '@/assets/CountryList.json'
import { debounce } from 'lodash'
import locationMixins from '@/mixins/locationMixins'

import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'

import CustomerTypeAhead from "@/components/CustomerTypeAhead.vue";
import LocationPicker from '@/components/Map/LocationPicker'
import LocationSection from '@/views/Location/LocationSection'

import LinkModal from '@/components/LinkModal'
import ViewAttachments from "./ViewAttachments.vue";
import Holiday from './Holiday.vue';
const L = window.L
const default_coords = {
    latitude: 18.002804952844535,
    longitude: -76.78970255393327,
}
export default {
    name: 'companySettings',
    mixins: [permissionsMixins, popupMixins, locationMixins],
    components: { LinkModal, LocationPicker, CustomerTypeAhead, LocationSection,ViewAttachments,Holiday },
    data() {
        return {
            tabIdx: 0,
            model: {
                name: 'My Company',
                email: '',
                phone: '',
                location_section_id: null,
                location: null,
                section_name: null,
                address1: '',
                address2: '',
                zip_code: '',
                city: 'Kingston',
                county: '',
                country_code: 'JM',
                state: null,
                latitude: 0,
                longitude: 0,
                postal: '',
                logo: '',
                tagline: '',
                text_color: '#000000',
                secondary_background_color: '#000000',
                background_color: '#ffffff',
                customer_id: null,
                time_zone: -300,
            },
            imageModel: {},
            imageHeight: 60,
            imageWidth: 60,
            filelist: [],
            isVisible: false,
            showModal: false,
            uploading: false,
            submitting: false,
            loaded: false,
            isSearchMode : null,
        }
    },
    async mounted() {
        await this.$store.dispatch('company/fetch')
        const country_code = this.model.country_code
        console.log('country_code', country_code)
        this.$store.dispatch('locations/fetchstate', country_code)
        const { attachments } = this.settings
        this.storeAttachments(attachments)
    },
    computed: {
        componentName() { return this.$translate('company_settings') },
        countries() {
            return this.$store.state.locations.country
        },
        states() {
            return this.$store.state.locations.states
        },
        settings() {
            const data = this.$store.state.company.settings
            return data
        },
        attachments() {
            return this.$store.state.companyAttachmentsStore.attachments
        },

        mediaBaseUrl() {
            return this.$store.getters['mediaBaseUrl']
        },
        mapLocation() {
            const _location = {
                ...(this.model || {})
            }
            let {
                latitude,
                longitude
            } = _location
            latitude = isNaN(parseFloat(latitude)) ? default_coords.latitude : parseFloat(latitude)
            longitude = isNaN(parseFloat(longitude)) ? default_coords.longitude : parseFloat(longitude)
            try {
                if (
                    !(
                        latitude > -90 &&
                        latitude < 90 &&
                        longitude > -180 &&
                        longitude < 180
                    )
                ) {
                    console.log('invalid coordinates', {
                        latitude,
                        longitude,
                    })
                    throw new Error('Invalid Coordinates')
                }
            } catch (error) {
                console.error('mapLocation', error)
                ////////
                latitude = default_coords.latitude
                longitude = default_coords.longitude
            }

            const center = new L.latLng(latitude, longitude)
            this.$set(_location, 'lat', latitude)
            this.$set(_location, 'lng', longitude)
            this.$set(_location, 'center', center)
            console.log('_location',_location)
            return _location
        },
    },
    watch: {
        settings: {
            handler: function (val) {
                this.model = val
                if (val.country_code == null || val.country_code == "Jamaica") {
                    this.$set(this.model, 'country_code', 'JM')
                } else {
                    this.$set(this.model, 'country_code', val.country_code)
                }
            },
            deep: true,
        },

        'settings.company_images': {
            handler: function (items) {
                this.storeAttachments(items)
            },
            deep: true,
        },
        'model.address1': debounce(function (val) {
            // this.$set(this.model, 'address1', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        'model.address2': debounce(function (val) {
            this.$set(this.model, 'address2', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        'model.city': debounce(function (val) {
            this.$set(this.model, 'city', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),
        'model.state': debounce(function (val) {
            this.$set(this.model, 'state', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        'model.postal_code': debounce(function (val) {
            this.$set(this.model, 'postal_code', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        'model.country_code': function (val) {
            //this.$store.dispatch('locations/fetchstate', val)
            this.$set(this.model, 'country_code', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        },
    },
    created() {
        this.$store.dispatch('itemType/fetchAll')
        this.$store.dispatch('locations/fetchCountry')
    },

    methods: {
        setLocationListMode() {
            return this.$refs['locationSectionRef']?.setSearchMode()
        },

        uploadClicked() {
            this.$store.dispatch('js_report/fetchCredentials')
        },
        onSubmit() {
            event.preventDefault()
            this.uploading = true;
            console.log(
                'Perfect! Now implement some way to upload these files: '
            )
            console.log(this.filelist)
            this.createAttachment()
                .then(() => {
                    this.uploading = false;
                })
                .catch((error) => {
                    console.log(error)
                    this.uploading = false;
                })
        },

        storeAttachments(attachments) {
            if (attachments) {                
                this.$store.dispatch(
                    'companyAttachmentsStore/load',
                    attachments || []
                )
            }
        },
        renameFile(fileIndex, newName) {
            const file = this.filelist[fileIndex].file
            var newFile = new File(
                [file],
                `${newName}.${this.filelist[fileIndex].extension}`,
                {
                    type: file.type,
                }
            )

            // Rebuild File Obj for file list array
            const fileName = newFile.name.replace(/\.[^/.]+$/, '')
            const extension = newFile.name.split('.').pop()

            this.filelist[fileIndex] = {
                fileName: fileName,
                extension: extension,
                file: newFile,
            }
        },

        onChange(event) {
            const totalImagesCount = (this.filelist.length + 1) + this.attachments.length
            if (totalImagesCount > 5) {
                this.doToast(this.$translate('error'), this.$translate('max_image_alert'), 'danger')
                return false;
            }
            let allowedTypes = ['png', 'jpg', 'jpeg']
            var fileName = event.target.files[0].name;
            var fileExtension = fileName.split('.').pop();
            let maxFileSize = this.$maxFileSize
            if (!allowedTypes.includes(fileExtension.toLowerCase())) {
                this.doToast(this.$translate('error'), this.$translate('settings_file_type_alert'), 'danger')
                return false;
            }
            if (maxFileSize < event.target.files[0].size) {
                this.doToast(this.$translate('error'), this.$translate('file_size_alert'), 'danger')
                return false
            }
            const img = new Image();
            img.src = URL.createObjectURL(event.target.files[0]);
            let imageValid = true;
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const maxWidth = 600;
                const maxHeight = 350;
                if (width !== maxWidth && height !== maxHeight) {
                    imageValid = false;
                    this.doToast(this.$translate('error'), `${this.$translate('image_size_alert')} 600x350.`, 'danger')
                    return false
                }
                if (imageValid) {
                    const fileArray = [...event.target.files] //put the files in a temporary array
                    fileArray.forEach(file => {
                        const fileName = file.name.replace(/\.[^/.]+$/, '') //extract filename (no extension) from the file full name
                        const extension = file.name.split('.').pop() //extract extensionfrom the file fullname
                        this.filelist.push({
                            fileName: fileName,
                            extension: extension,
                            file: file,
                        }) //store selected files and additional data in our array
                    })
                }
            }
        },
        onChangeDrop(event) {
            let allowedTypes = this.$allowedTypes
            let uploadedFileName = event.dataTransfer.files[0].name;
            let fileExtension = uploadedFileName.split('.').pop();
            let maxFileSize = this.$maxFileSize
        
            if (!allowedTypes.includes(fileExtension.toLowerCase())) {
                this.doToast(this.$translate('error'), this.$translate('invalid_file_type'), 'danger')
                return false;
            }
            if (maxFileSize < event.dataTransfer.files[0].size) {
                this.doToast(this.$translate('error'), this.$translate('file_size_alert'), 'danger')
                return false
            }
            const img = new Image();
            img.src = URL.createObjectURL(event.dataTransfer.files[0]);
            let imageValid = true;
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const maxWidth = 600;
                const maxHeight = 350;
                if (width !== maxWidth && height !== maxHeight) {
                    imageValid = false;
                    this.doToast(this.$translate('error'), `${this.$translate('image_size_alert')} 600x350.`, 'danger')
                    return false
                }
                if (imageValid) {
                    const fileArray = [...event.dataTransfer.files] //put the files in a temporary array
                    console.log('is fileArray',fileArray);
                    fileArray.forEach(file => {
                        const fileName = file.name.replace(/\.[^/.]+$/, '') //extract filename (no extension) from the file full name
                        const extension = file.name.split('.').pop() //extract extensionfrom the file fullname
                        this.filelist.push({
                            fileName: fileName,
                            extension: extension,
                            file: file,
                        }) //store selected files and additional data in our array
                    })
                }
            }
        },
        remove(i) {
            this.filelist.splice(i, 1)
        },
        removeAll(i) {
            this.filelist.splice(i, i.length)
        },
        setModel(item) {

            this.imageModel = { ...item }
            this.isVisible = true
        },

        dragover(event) {
            event.preventDefault()
        },
        drop(event) {
            event.preventDefault()
            this.onChangeDrop(event)
        },
        async createAttachment() {
            try {
                this.uploading = true
                const files = this.filelist.map(file => file.file)
                const p = await this.getCurrentLocation()
                console.log('coordinates', p)
                const lat = p.coords.latitude
                const long = p.coords.longitude
                // const file_extension =  files[0].name.split('.').pop()
                let { keys } = await this.$store.dispatch(
                    's3files/s3upload',
                    files
                )
                let url = []
                keys.forEach(key => {
                    url.push(`${this.mediaBaseUrl}/${key}`)
                })
                const newFiles = []
                files.forEach((element, i) => {
                    newFiles.push({
                        name: element.name,
                        url: url[i],
                        file_extension: element.name.split('.').pop(),
                        lat: lat,
                        long: long,
                    })
                })
                this.$store.dispatch('companyAttachmentsStore/merge', {
                    newFiles,
                })
                // Hide modal after success
                this.showModal = false
                this.genericToast(
                    this.componentName,
                    this.$translate('uploaded'),
                    'success',
                    this.$translate(`attachment_uploaded_alert`)
                )
                this.removeAll(this.filelist)
            } catch (error) {
                this.doToast(this.$translate('error'), this.$translate('error_storing_attachment'), 'danger')
            } finally {
                this.uploading = false
            }
        },
        deleteAttachment(hash) {
            this.$store.dispatch('companyAttachmentsStore/delete', hash)
            this.isVisible = false
        },
        fetchState(event) {
            this.model.state = null;
            const country_code = event
            this.$store.commit('locations/SET_STATES', null);
            this.$store.dispatch('locations/fetchstate', country_code)
        },
        async fetchCoordinates() {
            // if (this.isReadOnly) return
            if(this.tabIdx == 1){
                let coords = {
                latitude: 0,
                longitude: 0
            }
            try {
                const {
                    country_code,
                    city,
                    address1, state
                } = this.model

                // console.log("this.model.......",this.model)
                if (!(country_code || city || address1 || state))
                    throw new Error('Invalid Address!')

                coords = await this.$store.dispatch(
                    'locations/geocodeAddress',
                    this.model
                )
            } catch (err) {
                //console.log('fetchCoordinates error', err)
            } finally {
                for (const key in coords) {
                    this.$set(this.model, key, coords[key])
                }
                this.$emit('update-location-model', {
                    ...this.model
                })
            }
            }
        },
        setCoordinates(coords) {
            const {
                lat: latitude,
                lng: longitude
            } = coords
            this.$set(this.model, 'latitude', latitude)
            this.$set(this.model, 'longitude', longitude)
        },
        getLocation(locationData) {
            const country_code = locationData.data.results[0].components.country_code.toUpperCase()
            this.$set(this.model, 'city', locationData.data.results[0].components.city)
            this.$set(this.model, 'state_name', locationData.data.results[0].components.state)
            this.$set(this.model, 'county', locationData.data.results[0].components.county)
            this.$set(this.model, 'country_code', locationData.data.results[0].components.country_code.toUpperCase())
            this.$store.dispatch('locations/fetchstate', country_code)
            this.$set(this.model, 'address1', (locationData.data.results[0].components.suburb) ? locationData.data.results[0].components.suburb : locationData.data.results[0].components.suburb)
            if (country_code === "US" || country_code === "PH") {
                this.$set(this.model, 'zip_code', locationData.data.results[0].components.postcode)
            } else {
                this.$set(this.model, 'postal_code', locationData.data.results[0].components.postcode)
            }
            // this.$set(this.model, 'postal_code', locationData.data.results[0].components.postcode)

        },

        // async updateCompany() {
        //     this.submitting = true
        //     // try {
        //     this.imageModel = this.attachments

        //     const newmodel = { ...this.model, attachments: this.imageModel }
        //     console.log("newmodel", newmodel)
        //     await this.$store.dispatch('company/update', newmodel).then(() => {
        //         this.genericToast(this.componentName, this.$translate('uploaded'), 'success', `${this.componentName} ${this.$translate('update_alert')}`)
        //     }).catch(error => {
        //         this.doToast(this.$translate('failed'), error.message, 'danger')
        //     }).finally(
        //         this.submitting = false
        //     )

        // },
        async updateCompany() {
            this.submitting = true;

            try {
                this.imageModel = this.attachments;
                const newmodel = { ...this.model, attachments: this.imageModel };
                console.log("newmodel", newmodel);

                await this.$store.dispatch('company/update', newmodel);

                this.genericToast(this.componentName, this.$translate('uploaded'), 'success', `${this.componentName} ${this.$translate('update_alert')}`);
            } catch (error) {
                this.doToast(this.$translate('failed'), error.message, 'danger');
            } finally {
                this.submitting = false;
            }
        },

        parseLocation(
            {
                id,
                name,
                address1,
                address2,
                city,
                postal_code,
                state_name,
                zip_code,
                country_code,
                latitude,
                longitude,
                // map_reference,
                is_warehouse,
            },
            trigger
        ) {
            console.log('parseLocation trigger', trigger)
            this.location = {
                id,
                name,
                address1,
                address2,
                city,
                state_name,
                zip_code,
                postal_code,
                country_code,
                latitude,
                longitude,
                // map_reference,
                is_warehouse,
            }
        },

        triggerUpdateLocation(_location) {
            const {
                currentSection: { location, id, name },
            } = this.model
            if (!_location.id || _location.id != (location && location.id)) {
                if (location || id || name) {
                    this.$set(this.model, 'id', null)
                    this.$set(this.model, 'name', '')
                    this.$set(this.model, 'location', null)
                }
                this.parseLocation(_location, 'triggerUpdateLocation')
            } else {
                this.parseLocation(_location, 'triggerUpdateLocation')
            }

            console.log('triggerUpdateLocation', _location)
        },
        selectText(i) {
        // Use $refs to access the input element and call select() on it
        this.$refs.inputField[i].select();
    },
    },
}
</script>
<style></style>
